<template>
  <div class="tarifs-block" id="tariff">
    <div
      class="price-card default"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <div class="price">
        <div class="top-card">
          <div class="name-tarif" itemprop="name">START</div>
          <div class="price-name" itemprop="price">Free</div>
          <div class="price-info" itemprop="description">
            Free plan, suitable for designing a personal interior
          </div>
        </div>
        <div class="price-action">
          <DownloadLauncherButton
            icon=""
            :isDownload="true"
            labelNotAuth="Log in and download"
            :add-version-to-label="false"
          />
        </div>
      </div>
      <div class="info-tarif">
        <div class="desc-tarif">The plan includes</div>
        <div class="main-desc-tarif">
          <ul>
            <li>3 projects per month</li>
            <li>Entire model library</li>
            <li>Creating your own layouts</li>
            <li>Saving different designs for a single layout</li>
            <li>Interior video fly-throughs (3 per month)</li>
            <li>3D tours (3 per month)</li>
            <li>VR mode</li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="price-card border"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <div class="circle" :class="{right}" />
      <div class="price">
        <div class="top-card">
          <div class="name-tarif" itemprop="name">
            {{ $t('premium') }}
          </div>
          <div class="price-name" itemprop="price">
            <div v-if="isDflat" class="cost">490 ₽</div>
            <div v-if="!isDflat" class="cost">
              {{ $t('dollars9') }}
            </div>
            <div class="monetary">/30 days</div>
            <meta itemprop="priceCurrency" />
          </div>
          <div class="price-info" itemprop="description">
            Plan designed to maximize personal use of the program
          </div>
        </div>
        <div class="price-action">
          <ui-link to="/pay/premium">
            <ui-button class="full-width" color="primary">
              Start
            </ui-button>
          </ui-link>
          <meta
            itemprop="url"
            content="https://dreamflat.design/pay/premium"
          />
        </div>
      </div>
      <div class="info-tarif">
        <div class="desc-tarif">Includes:</div>
        <div class="main-desc-tarif">
          <ul>
            <li>All features of Start plan</li>
            <li>5 projects per month</li>
            <li>Watermarks removal</li>
            <li>Kitchen constructor</li>
            <li>Work with primitives</li>
            <li>Furniture resizing</li>
            <li>
              Increased limits:
              <div class="sub-li">
                10 video fly-throughs, 10 3D tours
              </div>
            </li>
            <li>
              If you want to add more content to the plan, please
              contact us at
              <a href="mailto:support@dreamflat.design"
                >support@dreamflat.design</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="price-card border"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <div class="price">
        <div class="square" :class="{right}" />
        <div class="top-card">
          <div class="name-tarif" itemprop="name">
            {{ $t('designer') }}
          </div>
          <div class="price-name" itemprop="price">
            <div v-if="isDflat" class="cost">1 490 ₽</div>
            <div v-if="!isDflat" class="cost">
              {{ $t('dollars29') }}
            </div>
            <div class="monetary">/30 days</div>
            <meta itemprop="priceCurrency" />
          </div>
          <div class="price-info" itemprop="description">
            One workplace for a professional
          </div>
        </div>
        <div class="price-action">
          <ui-link to="/pay/designer">
            <ui-button
              class="full-width"
              color="primary"
              :label="'Start'"
            />
          </ui-link>
          <meta
            itemprop="url"
            content="https://dreamflat.design/pay/designer"
          />
        </div>
      </div>
      <div class="info-tarif">
        <div class="desc-tarif">Includes:</div>
        <div class="main-desc-tarif">
          <ul>
            <li>All Premium features</li>
            <li>20 projects per month</li>
            <li>Upload your models (30 pcs)</li>
            <li>Upload finish materials (30 pcs)</li>
            <li>
              Increased limits:
              <div class="sub-li">50 fly-throughs, 50 3D tours</div>
            </li>
            <li>
              If you want to add more content to the plan, please
              contact us at
              <a href="mailto:support@dreamflat.design"
                >support@dreamflat.design</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="price-card border"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <div class="price">
        <div class="top-card">
          <div class="name-tarif">
            {{ $t('propDevCaps') }}
          </div>
          <div v-if="isDflat" class="price-name">
            17 500 ₽
            <div class="monetary">/{{ $t('month') }}</div>
          </div>
          <div v-if="!isDflat" class="price-name">
            {{ $t('dollars290') }}
            <div class="monetary">/30 days</div>
          </div>
          <div class="price-info">
            A special plan that allows developers to present their
            real estate directly in the application
          </div>
        </div>
        <div class="price-action">
          <ui-link to="/pay/property">
            <ui-button
              class="full-width"
              unelevated
              color="primary"
              :label="'Start'"
            />
          </ui-link>
        </div>
      </div>
      <div class="info-tarif">
        <div class="desc-tarif">Includes:</div>
        <div class="main-desc-tarif">
          <ul>
            <li>All Designer+ features</li>
            <li>100 projects per month</li>
            <li>Upload your models (50 pcs)</li>
            <li>Upload finish materials (50 pcs)</li>
            <li>
              Adding one real estate object (up to 15 unique layouts)
              to DreamFlat with your website link
            </li>
            <li>The ability to integrate 3D tours on your website</li>
            <li>Priority support via messenger or email</li>
            <li>
              Increased limits:
              <div class="sub-li">100 fly-throughs, 100 3D tours</div>
            </li>
            <li>
              If you want to add more content to the plan, please
              contact us at
              <a href="mailto:support@dreamflat.design"
                >support@dreamflat.design</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="price-card border"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <div class="price">
        <div class="triangle" :class="{right}" />
        <div class="top-card">
          <div class="name-tarif" itemprop="name">
            {{ $t('enterpriseCaps') }}
          </div>
          <div class="price-name" itemprop="price">
            <div v-if="isDflat" class="cost">24 900 ₽</div>
            <div v-if="!isDflat" class="cost">
              {{ $t('dollars390') }}
            </div>
            <div class="monetary">/30 days</div>
          </div>
          <div class="price-info">
            Corporate subscription for manufacturers and retailers
            intended to stimulate the growth of their businesses.
            <br /><br />
            Plan already includes 10 accounts.
          </div>
        </div>
        <div class="price-action">
          <ui-link to="/pay/enterprise">
            <ui-button
              class="full-width"
              color="primary"
              :label="'Start'"
            />
          </ui-link>
          <meta
            itemprop="url"
            content="https://dreamflat.design/pay/enterprise"
          />
        </div>
      </div>
      <div class="info-tarif">
        <div class="desc-tarif">Includes:</div>
        <div class="main-desc-tarif">
          <ul>
            <li>All Property Developers features</li>
            <li>100 projects per month</li>
            <li>Upload your models (100 pcs)</li>
            <li>Upload finish materials (100 pcs)</li>
            <li>
              Possibility to post your models in DreamFlat with your
              website link
            </li>
            <li>
              Adding one real estate object (up to 15 unique layouts)
              to DreamFlat with your website link
            </li>
            <li>
              Integration of 3D tours with products on your website
            </li>
            <li>Priority support via messenger or email</li>
            <li>
              Increased limits (per account):
              <div class="sub-li">200 video tours, 200 3D tours</div>
            </li>
            <li>
              If you want to add more content to the plan, please
              contact us at
              <a href="mailto:support@dreamflat.design"
                >support@dreamflat.design</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useDirectionStore} from '~/store/direction.store';

const runtimeConfig = useRuntimeConfig();
const isDflat =
  runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');
const direction = useDirectionStore();
const right = computed(() => direction.$state.isRight);
</script>

<style scoped lang="scss">
.tarifs-block {
  margin-top: 24px;
}
.price-card {
  padding: 32px;
  letter-spacing: 0.03em;
  background: #f6f8fd;
  border-radius: 16px;
  display: flex;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;

  gap: $g-8;

  .circle {
    width: 128px;
    height: 128px;
    background: #e1e5f0;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(25%, -20%);

    &.right {
      right: auto;
      left: -40px;
    }
  }

  .square {
    width: 128px;
    height: 128px;
    background: #e1e5f0;
    border-radius: 10%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(25%, -20%);

    &.right {
      right: auto;
      left: -40px;
    }
  }

  .triangle {
    width: 128px;
    height: 128px;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-bottom: 100px solid #e1e5f0;
    border-radius: 20%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(25%, -20%);

    &.right {
      right: auto;
      left: -40px;
    }
  }

  .price {
    width: 256px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    .top-card {
      margin-bottom: auto;
      width: 100%;
    }

    .price-action {
      margin-top: 18px;
      button {
        border-radius: 8px;
        width: 100%;
        // text-transform: capitalize;
        font-weight: 600;
      }
      .price-button {
        box-shadow: 0 3px 10px rgb(36 145 231 / 25%);

        border-radius: 8px;
        padding-right: 32px;
        padding-left: 32px;
        font-weight: 600;
        // text-transform: capitalize;
      }
    }
  }

  .info-tarif {
    // height: 500px;
    width: 500px;
    .desc-tarif {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.03em;
      color: #3d424a;
    }

    ul {
      list-style: none;
      margin: 12px 0 0 0;
      padding: 0;

      li {
        padding-left: 1em;
        text-indent: -0.7em;
        margin-bottom: 4px;

        .sub-li {
          margin-left: 0.7rem;
          font-weight: 400;
          font-size: 14px;

          letter-spacing: 0.02em;

          color: #839aaf;
        }
      }

      li::before {
        content: '• ';
        color: $primary;
      }
    }
  }

  .name-tarif {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
    color: #3d424a;
  }

  .price-name {
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
    color: $primary;
    display: flex;
    align-items: baseline;
    .monetary {
      font-size: 14px;
    }
  }

  .price-info {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #839aaf;
  }

  &.default {
    .name-tarif {
      color: #839aaf;
    }

    .price-name {
      color: #64686e;
    }

    .price-info {
    }
  }

  @media (max-width: $md) {
    flex-direction: column;
    padding: 16px;
    gap: 16px;
    padding-bottom: 72px;

    .price-action {
      position: absolute;
      bottom: 16px;
      width: calc(100% - 32px);
    }
  }
}
</style>
